"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitNumber = void 0;
const ZERO_ARRAY = [0];
const splitNumber = (num) => {
    if (num < 0)
        return ZERO_ARRAY;
    return num.toString().split('').map(Number);
};
exports.splitNumber = splitNumber;
